"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseService = void 0;
const config_1 = require("@app/config");
const http_service_1 = require("./http.service");
const csvtojson_1 = __importDefault(require("csvtojson"));
const object_1 = require("@utils/object");
const local_store_service_1 = __importDefault(require("./local-store.service"));
class WarehouseService extends http_service_1.HttpService {
    constructor() {
        super();
    }
    getTokenList() {
        return __awaiter(this, void 0, void 0, function* () {
            const { object: tokenList } = yield this.httpClient.get(config_1.CONFIG.tokenListUrl);
            return JSON.parse(tokenList);
        });
    }
    getTranslations(language) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.languageLibrary) {
                let rawTranslations;
                try {
                    const { object } = yield this.httpClient.get(config_1.CONFIG.localizations);
                    rawTranslations = object;
                    local_store_service_1.default.setLanguageLibrary(object);
                }
                catch (error) {
                    console.error("Loading translations was failed");
                    rawTranslations = local_store_service_1.default.getLanguageLibrary();
                }
                if (!rawTranslations) {
                    return undefined;
                }
                const result = yield (0, csvtojson_1.default)().fromString(rawTranslations);
                this.languageLibrary = {};
                result.forEach((_a) => {
                    var { field } = _a, languages = __rest(_a, ["field"]);
                    Object.entries(languages).forEach(([language, value]) => {
                        (0, object_1.setDotProperty)(this.languageLibrary, `${language}.${field}`, value);
                    });
                });
            }
            return this.languageLibrary[language];
        });
    }
}
exports.WarehouseService = WarehouseService;
WarehouseService.instance = new WarehouseService();
WarehouseService.getInstance = () => WarehouseService.instance;
